import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  return <section className="w-full bg-white py-16 md:py-24" data-id="element-14">
      <div className="max-w-5xl mx-auto px-4" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.7
      }} data-id="element-16">
          <div className="text-center mb-12" data-id="element-17">
            <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl font-bold text-[#2D3436]" data-id="element-18">
              ¿Es para ti?
            </h2>
          </div>

          <div className="grid md:grid-cols-2 gap-8" data-id="element-19">
            {/* For you */}
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="bg-[#5B8F7B]/5 rounded-2xl p-6 md:p-8 border-t-4 border-[#5B8F7B]" data-id="element-20">
              <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#5B8F7B] mb-6" data-id="element-21">
                Esto ES para ti si...
              </h3>

              <ul className="space-y-4" data-id="element-22">
                <li className="flex items-start gap-3" data-id="element-23">
                  <div className="flex-shrink-0 w-6 h-6 bg-[#5B8F7B] rounded-full flex items-center justify-center mt-0.5" data-id="element-24">
                    <CheckIcon className="w-4 h-4 text-white" data-id="element-25" />
                  </div>
                  <span className="text-[#2D3436]" data-id="element-26">
                    Eres mujer de 30 a 55 años que nota que su vientre crece
                    bajo estrés.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-27">
                  <div className="flex-shrink-0 w-6 h-6 bg-[#5B8F7B] rounded-full flex items-center justify-center mt-0.5" data-id="element-28">
                    <CheckIcon className="w-4 h-4 text-white" data-id="element-29" />
                  </div>
                  <span className="text-[#2D3436]" data-id="element-30">
                    Eres emprendedora o empleada con jornadas intensas que se
                    siente pesada al final del día.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-31">
                  <div className="flex-shrink-0 w-6 h-6 bg-[#5B8F7B] rounded-full flex items-center justify-center mt-0.5" data-id="element-32">
                    <CheckIcon className="w-4 h-4 text-white" data-id="element-33" />
                  </div>
                  <span className="text-[#2D3436]" data-id="element-34">
                    Eres madre que no tiene tiempo para ir 2 horas al gimnasio
                    pero quiere sentirse ligera.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-35">
                  <div className="flex-shrink-0 w-6 h-6 bg-[#5B8F7B] rounded-full flex items-center justify-center mt-0.5" data-id="element-36">
                    <CheckIcon className="w-4 h-4 text-white" data-id="element-37" />
                  </div>
                  <span className="text-[#2D3436]" data-id="element-38">
                    Sientes que "todo te cae mal" y te inflamas después de cada
                    comida.
                  </span>
                </li>
              </ul>
            </motion.div>

            {/* Not for you */}
            <motion.div initial={{
            opacity: 0,
            x: 20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-[#E17055]/5 rounded-2xl p-6 md:p-8 border-t-4 border-[#E17055]" data-id="element-39">
              <h3 className="font-['Playfair_Display'] text-xl font-semibold text-[#E17055] mb-6" data-id="element-40">
                Esto NO es para ti si...
              </h3>

              <ul className="space-y-4" data-id="element-41">
                <li className="flex items-start gap-3" data-id="element-42">
                  <div className="flex-shrink-0 w-6 h-6 bg-[#E17055] rounded-full flex items-center justify-center mt-0.5" data-id="element-43">
                    <XIcon className="w-4 h-4 text-white" data-id="element-44" />
                  </div>
                  <span className="text-[#2D3436]" data-id="element-45">
                    Buscas una solución mágica de pérdida de peso de 20 libras
                    en 3 días.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-46">
                  <div className="flex-shrink-0 w-6 h-6 bg-[#E17055] rounded-full flex items-center justify-center mt-0.5" data-id="element-47">
                    <XIcon className="w-4 h-4 text-white" data-id="element-48" />
                  </div>
                  <span className="text-[#2D3436]" data-id="element-49">
                    No estás dispuesta a dedicar 5 minutos al día a técnicas de
                    respiración.
                  </span>
                </li>
                <li className="flex items-start gap-3" data-id="element-50">
                  <div className="flex-shrink-0 w-6 h-6 bg-[#E17055] rounded-full flex items-center justify-center mt-0.5" data-id="element-51">
                    <XIcon className="w-4 h-4 text-white" data-id="element-52" />
                  </div>
                  <span className="text-[#2D3436]" data-id="element-53">
                    Eres atleta de alto rendimiento que busca suplementación
                    deportiva avanzada.
                  </span>
                </li>
              </ul>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}